import { render, staticRenderFns } from "./OfficeContentComponent.vue?vue&type=template&id=cef994d4&scoped=true&"
import script from "./OfficeContentComponent.vue?vue&type=script&lang=js&"
export * from "./OfficeContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./OfficeContentComponent.vue?vue&type=style&index=0&id=cef994d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef994d4",
  null
  
)

export default component.exports